import {
  IDisease,
  IMedicine,
  IPatientData,
  IScreening,
  ISymptons,
  IClinic,
  IProfessional,
  IAllergy,
} from '../types'
import { IAttachment } from '@/modules/Attachment/types'
import { IScreeningNps } from '@/modules/NPS/types'
export default class Screening {
  private _token: string
  private _professionalType: string | null
  private _steps: string[] | null
  private _hasSymptons: boolean | null
  private _hasDiseaseOrMedicines: boolean | null
  private _symptons: ISymptons | null
  private _diseases: IDisease[] | null
  private _medicines: IMedicine[] | null
  private _patient: IPatientData | null
  private _clinic: IClinic | null
  private _professional: IProfessional | null
  private _startedAt: string | null
  private _finishedAt: string | null
  private _currentStep: number
  private _allergies: IAllergy
  private _attachments: IAttachment[]
  private _edited: boolean
  private _nps: IScreeningNps
  public state: IScreening

  constructor(screening: IScreening) {
    this._token = screening.token
    this._professionalType = screening.professionalType
    this._steps = screening.steps
    this._hasSymptons = screening.hasSymptons
    this._hasDiseaseOrMedicines = screening.hasDiseaseOrMedicines
    this._symptons = screening.symptons
    this._diseases = screening.diseases
    this._medicines = screening.medicines
    this._patient = screening.patient
    this._clinic = screening.clinic
    this._professional = screening.professional
    this._startedAt = screening.startedAt
    this._finishedAt = screening.finishedAt
    this._currentStep = screening.currentStep
    this._allergies = screening.allergies
    this._attachments = screening.attachments
    this._edited = screening.edited
    this._nps = screening.nps
  }

  get token(): string {
    return this._token
  }

  set token(value: string) {
    this._token = value
  }

  get professionalType(): string {
    return this._professionalType
  }

  set professionalType(value: string) {
    this._professionalType = value
  }

  get patient(): IPatientData {
    return this._patient
  }

  set patient(value: IPatientData) {
    this._patient = value
  }

  get steps(): string[] {
    return this._steps
  }

  set steps(value: string[]) {
    this._steps = value
  }

  get hasSymptons(): boolean {
    return this._hasSymptons
  }

  set hasSymptons(value: boolean) {
    this._hasSymptons = value
  }

  get hasDiseaseOrMedicines(): boolean {
    return this._hasDiseaseOrMedicines
  }

  set hasDiseaseOrMedicines(value: boolean) {
    this._hasDiseaseOrMedicines = value
  }

  get symptons(): ISymptons {
    return this._symptons
  }

  set symptons(value: ISymptons) {
    this._symptons = value
  }

  get diseases(): IDisease[] {
    return this._diseases
  }

  set diseases(value: IDisease[]) {
    this._diseases = value
  }

  get medicines(): IMedicine[] {
    return this._medicines
  }

  set medicines(value: IMedicine[]) {
    this._medicines = value
  }

  get clinic(): IClinic {
    return this._clinic
  }

  set clinic(value: IClinic) {
    this._clinic = value
  }

  get professional(): IProfessional {
    return this._professional
  }

  set professional(value: IProfessional) {
    this._professional = value
  }

  get startedAt(): string {
    return this._startedAt
  }

  set startedAt(value: string) {
    this._startedAt = value
  }

  get finishedAt(): string {
    return this._finishedAt
  }

  set finishedAt(value: string) {
    this._finishedAt = value
  }

  get currentStep(): number {
    return this._currentStep
  }

  set currentStep(value: number) {
    this._currentStep = value
  }

  get allergies(): IAllergy {
    return this._allergies
  }

  set allergies(value: IAllergy) {
    this._allergies = value
  }

  get attachments(): IAttachment[] {
    return this._attachments
  }

  set attachments(value: IAttachment[]) {
    this._attachments = value
  }

  get edited(): boolean {
    return this._edited
  }

  set edited(value: boolean) {
    this._edited = value
  }

  get nps(): IScreeningNps {
    return this._nps
  }

  set nps(value: IScreeningNps) {
    this._nps = value
  }
}
export const buildScreening = (screening: IScreening): Screening => {
  return new Screening(screening)
}
